export const agentConstants = {
    GET_AGENT_OPTIONS_REQUEST: 'GET_AGENT_OPTIONS_REQUEST',
    GET_AGENT_OPTIONS_SUCCESS: 'GET_AGENT_OPTIONS_SUCCESS',
    GET_AGENT_OPTIONS_FAILURE: 'GET_AGENT_OPTIONS_FAILURE',
};

export const AgentStatus = {
    Pending: 1,
    Submit: 2,
    Approved: 3,
    Rejected: 4,
    ReSubmit: 5
} as const;
